import { useState, useEffect } from 'react'
import { noop, throttle } from 'lodash'

export const useInfiniteScroll = (
  targetDataElmId,
  callback,

  // NOTE: This function arg list wasn't carefully considered and was tied to the initial deployment
  // of a feature that used this which is why this field is here. We can't remove this without more effort
  // tracking down all call sites since it's in the external API for this module.
  scrollCallbackAllowed = true,

  threshold = 0,
  throttleTime = 700
) => {
  const [isFetching, setIsFetching] = useState(false)

  const onScroll = target =>
    throttle(() => {
      if (
        target.clientHeight + target.scrollTop + threshold >=
        target.scrollHeight
      ) {
        setIsFetching(true)
        callback()
      }
    }, throttleTime)

  // This hook should be only used in the graph mode which at the time means also using the auctionApplication wrapper.
  // These types of conditions arent favored but this will be removed once we dont need to support the old app header.
  const onScrollFunc = scrollCallbackAllowed ? onScroll : noop
  useEffect(() => {
    const target = document.querySelector(`[data-elm-id="${targetDataElmId}"]`)
    target.addEventListener('scroll', onScroll(target))
    return () => target.removeEventListener('scroll', onScrollFunc)
  }, [])

  return {
    isFetching,
    setIsFetching,
  }
}
